"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ExtensionsService", {
    enumerable: true,
    get: function() {
        return ExtensionsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _models = require("~/models");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ExtensionsService = class ExtensionsService {
    async extensionList(context, param) {
        return await _models.Extension.list(context, param.baseId);
    }
    async extensionRead(context, param) {
        const extension = await _models.Extension.get(context, param.extensionId);
        if (!extension) {
            _ncError.NcError.get(context).extensionNotFound(param.extensionId);
        }
        return extension;
    }
    async extensionCreate(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ExtensionReq', param.extension);
        const res = await _models.Extension.insert(context, _extends({}, param.extension, {
            fk_user_id: param.req.user.id
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.EXTENSION_CREATE, {
            extensionId: res.id,
            extension: param.extension,
            req: param.req
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'extension_create',
                payload: res
            }
        }, context.socket_id);
        return res;
    }
    async extensionUpdate(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ExtensionReq', param.extension);
        await this.extensionRead(context, param);
        const res = await _models.Extension.update(context, param.extensionId, param.extension);
        this.appHooksService.emit(_nocodbsdk.AppEvents.EXTENSION_UPDATE, {
            extensionId: param.extensionId,
            extension: param.extension,
            req: param.req
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'extension_update',
                payload: res
            }
        }, context.socket_id);
        return res;
    }
    async extensionDelete(context, param) {
        const extension = await this.extensionRead(context, param);
        const res = await _models.Extension.delete(context, param.extensionId);
        this.appHooksService.emit(_nocodbsdk.AppEvents.EXTENSION_DELETE, {
            extensionId: param.extensionId,
            req: param.req
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'extension_delete',
                payload: extension
            }
        }, context.socket_id);
        return res;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
ExtensionsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], ExtensionsService);
